import { useState } from 'react';
import { motion } from "motion/react";
import { useTranslation } from '../../i18n/useTranslation';
import { useIntroPageViewModel } from './introPageViewModel';
import { Offscreen } from 'src/lib/common/ui/Offscreen';
import styles from './IntroPage.module.scss';

import videoFileLandscape from 'src/assets/video/intro-landscape.mp4';
import videoFilePortrait from 'src/assets/video/intro-portrait.mp4';
import videoImageLandscape from 'src/assets/img/content/intro-landscape.jpg';
import videoImagePortrait from 'src/assets/img/content/intro-portrait.jpg';

export function IntroPage() {
  const { t } = useTranslation();
  const viewModel = useIntroPageViewModel();

  const nextButtonClick = () => {
    viewModel.gotToNextStep();
  };

  const [videoPlay, setVideoPlay] = useState(false);
  const onVideoPlay = () => {
    setVideoPlay(true);
  };

  return (
    <motion.div initial={{  opacity: 0 }} animate={{  opacity: 1 }} exit={{  opacity: 0 }} transition={{ duration: 0.3 }}>
      <div className={ styles.container } data-videoplay={ videoPlay ? 'true' : 'false' }>

        <Offscreen as='h1'>
          { t('intro_title') }
        </Offscreen>

        <div className={ styles.mediaBlock }>
          <picture>
            <source srcSet={ videoImagePortrait } media="(orientation: portrait)" />
            <source srcSet={ videoImageLandscape } media="(orientation: landscape)" />
            <img src={ videoImageLandscape } alt="" className={styles.videoFallback} />
          </picture>
          <video className={ styles.video } data-type="landscape" onPlay={ onVideoPlay } src={ videoFileLandscape } playsInline autoPlay muted></video>
          <video className={ styles.video } data-type="portrait" onPlay={ onVideoPlay } src={ videoFilePortrait } playsInline autoPlay muted></video>
        </div>

        <motion.div className={ styles.actionBlock } initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
          <div className={ styles.actionBlockInner }>
            <button type="button" onClick={ nextButtonClick } className={ styles.actionButton }>
              { t('intro_cta_start') }
            </button>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
}
